module.exports = __webpack_public_path__ + "img/ch09_03_洛洛店主.e1bed5d6.jpg";